import React, { useEffect, useState } from 'react';
import { styled } from "@mui/material/styles";
import PropTypes from 'prop-types';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { SnackbarActions } from '../../../../redux/actions/snackbar.actions';
import { CustomizedSnackbar } from '../../../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { loadCommentsType } from '../../../../redux/actions/lookups.action';
import { loadUsers } from '../../../../redux/actions/lookups.action';
import Select from 'react-select';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Grid,
    Button,
} from '@mui/material';

import {
    Close
} from '@mui/icons-material';
import { addNewComments } from '../../../../redux/actions/addComments.action';
import './AddNewCommentsPopup.css';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));
const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};


BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const AddNewCommentsPopup = (props) => {

    const dispatch = useDispatch();

    let CommentTypes = useSelector(state => state.loadCommentsTypes_Reducer.commentTypes);
    let userList = useSelector((state) => state.loadUsers_Reducer.usersList);



    const [open, setOpen] = React.useState(props && props.open);
    const [comments, setComments] = useState("");
    const [selectedParticipants, setSelectedParticipants] = React.useState([]);
    const [selectedCommentTypes, setSelectedCommentTypes] = useState({ value: '4', label: 'Public' });
    const [showParticipants, setShowParticipants] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [isParticipantsEmpty, setIsParticipantsEmpty] = useState(false);

    const handleSubmit = () => {

        let selectedParticipantsId;

        // Custom restriction
        if (selectedCommentTypes.value === '5') {
            if (selectedParticipants.length === 0) {
                setIsParticipantsEmpty(true);
                return false;
            }
        }

        if (selectedParticipants !== []) {
            setIsParticipantsEmpty(false);
            selectedParticipantsId = selectedParticipants.map(participant => participant.value).toString();
        }

        var req = {
            "objectId": props && props.commentId !== undefined && props.commentId !== '' ? props.commentId : null,
            "comment": comments !== "" ? comments : null,
            "commentTypeId": selectedCommentTypes !== null ? selectedCommentTypes.value : null,
            "viewerIds": selectedParticipants.length !== 0 ? selectedParticipantsId : null
        }


        dispatch(addNewComments(req));
        setIsSubmit(true);
        // if (props.callFrom === 0) {
        props.handlePageChange(1);

        if (props.pageNo === 1) {
            props.loadKeyResults();
        }
        // }


        // if (addNewComments_apiResponseCode === 200 && addNewComments_apiResponse === 'success') {
        dispatch(SnackbarActions(true, "success", "Comments Added"));
        props.toggleCommentsPopup(false);
        // }

        setTimeout(() => {

            props.loadComments(props && props.commentId !== undefined && props.commentId !== '' ? props.commentId : null);
            // props.loadKeyResults(props && props.commentId !== undefined && props.commentId !== '' ? props.commentId : null);
        }, 3000);


    }

    const handleParticipants = (selected) => {
        setIsParticipantsEmpty(false);
        setSelectedParticipants(selected);
    }

    const handleChangeCommentType = (selected) => {

        setSelectedCommentTypes(selected);
        if (selected.value === '5') {
            setShowParticipants(true);
        }
        else {
            setShowParticipants(false);
            setSelectedParticipants([]);
        }
    }
    useEffect(() => {
        dispatch(loadUsers());
        dispatch(loadCommentsType());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth="sm"
                maxWidth="sm"
                onClose={() => props.toggleCommentsPopup(false)}
            >

                <ValidatorForm
                    onSubmit={handleSubmit}
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={() => props.toggleCommentsPopup(false)}
                        className="modal-heading"
                    >
                        Add Your Comment

                    </BootstrapDialogTitle>

                    <DialogContent dividers>
                        <Box
                            alignItems="center"
                            display="flex"
                            justifyContent="center"
                            component="form"
                            autoComplete="off"
                        >
                            <Grid container spacing={2} item xs={12} className="grid-margins">
                                <Grid item xs={6} className="grid-margins">
                                    <Select
                                        className='customselect'
                                        defaultValue={{ value: '4', label: 'Public' }}
                                        placeholder="Select Comment Type"
                                        options={CommentTypes}
                                        onChange={handleChangeCommentType}
                                        isRequired={true}
                                        menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />

                                </Grid>
                                {showParticipants ? <Grid item xs={6} className="grid-margins">
                                    <Select
                                        options={userList}
                                        value={selectedParticipants}
                                        onChange={handleParticipants}
                                        placeholder="Select Who can view"
                                        isMulti={true}
                                    />
                                    {isParticipantsEmpty ? <p className='required-msg'>Please Select any</p> : null}
                                </Grid> : null}
                                <Grid item xs={12} className="grid-margins" sx={{marginBottom: "20px"}}>
                                    <TextValidator
                                        id="input-with-icon-textfield"
                                        variant="outlined"
                                        multiline
                                        fullWidth
                                        rows={5}
                                        label="Type your comments here"
                                        value={comments}
                                        onChange={(e) => setComments(e.target.value)}
                                        validators={["required"]}
                                        errorMessages={["Please fill out this field"]}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            className="theme-btn cancel-btn"
                            onClick={() => props.toggleCommentsPopup(false)}
                        >
                            Cancel
                        </Button>
                        &nbsp;
                        <Button variant="contained" className="theme-btn" type="submit" disabled={isSubmit}>
                            Submit
                        </Button>
                    </DialogActions>
                </ValidatorForm>
            </BootstrapDialog>
            <CustomizedSnackbar />
        </div>
    )
}

export default AddNewCommentsPopup;